import styles from "../../Css/List.module.scss";
import React, { useEffect, useState } from "react";
import {
    openDataBase, createElement, readElement,
    updateElement, deleteElement, allElements
} from "../../../../Helper/Indexeddb";
import { getPhysicTakeDetails, updateAmountPhysicalTakeArray } from '../../Services';
import {
    IonRow, IonCol, IonList, IonInput, IonLoading, useIonToast,
    IonFab, IonFabButton, IonIcon
} from "@ionic/react";
import { closeCircle, save, checkmarkCircleOutline } from 'ionicons/icons';


const List = ({ name, code, physicTakeHeaderCode, look, area, group, movements }) => {
    const [db, setDb] = useState(null);
    const [data, setBody] = useState([]);
    const [dataFull, setBodyFull] = useState([]);
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [viewAlert, setViewAlert] = useState(true);
    const [present] = useIonToast();
    const model = 'pyshicalTake';

    useEffect(() => {
        openDataBase()
            .then((db) =>{setDb(db)} )
            .catch((error) => console.error(error));
        
        const dataFull = { physicTakeHeaderCode: physicTakeHeaderCode, nameArtcicle: '', codeArticle: '', movements: 2, page: 1};
        getPhysicTakeDetails(dataFull).then((response) => {if (response.status && response.data) {setBodyFull(response.data);}});
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const intervalo = setInterval(() => { updateElements(db, 2);}, 120000);
        return () => clearInterval(intervalo);
    }); 

    useEffect(() => {
        setLoading(true);
        const data = {
            physicTakeHeaderCode: physicTakeHeaderCode,
            nameArtcicle: name,
            codeArticle: code,
            area: area,
            groupArticle: group,
            movements: movements,
            page: 1
        };
        getPhysicTakeDetails(data).then((response) => {
            if (response.status) {
                if (response.data) {
                    setBody(response.data);
                    setResults(response.data);
                    if(Object.keys(response.data).length === 0){
                        present({
                            message: 'No existen artículos para los criterios de búsqueda seleccionados del inventario.',
                            duration: 6000,
                            position: 'bottom',
                            color: 'secondary',
                            icon: closeCircle
                        })
                    }
                }
            } else {
                if(response.offline){
                    searchOffline();
                } else {
                    response.messages.map((message) => (
                        present({
                            message: message,
                            duration: 3000,
                            position: 'bottom',
                            color: 'danger',
                            icon: closeCircle
                        })
                    ));
                }
            }
            setLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [look]);

    useEffect(() => {
        if (name !== "") {
            const searchTermLower = name.toLowerCase();
            const newResults = Object.entries(results).filter(e => e[1].article_name.toLowerCase().includes(searchTermLower));
            let orderResults = {};
            newResults.forEach(function (element) {
                orderResults[element[0]] = element[1];
            })
            setResults(orderResults);
        } else {
            setResults(data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name]);

    useEffect(() => {
        if (code !== "") {
            const searchTermLower = code.toLowerCase();
            const newResults = Object.entries(results).filter(e => e[1].article_code.toLowerCase().includes(searchTermLower));
            let orderResults = {};
            newResults.forEach(function (element) {
                orderResults[element[0]] = element[1];
            })
            setResults(orderResults);
        } else {
            setResults(data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code]);

    const updateAmount = (item, articleId, area) => {
        const id = item.id_article + '-' + item.area_code;
        const value = document.getElementById(id).value;
        if (value !== "" && value !== undefined) {
            readElement(db, model, id).then(
                (response) => {
                    const article = {
                        id_physic_take: physicTakeHeaderCode,
                        warehouse_article_code: item.id_article,
                        area_code: item.area_code,
                        physic_quantity: value
                    };
                    if(response.status && response.data){
                        updateElement(db, model, {id: id, value: article}).then((data) => {
                            if(data.status){
                                results[articleId].area[area].quantity = value;
                                document.getElementById('total'+articleId).value = calculateTotal(articleId);
                                results[articleId].total = calculateTotal(articleId);
                            }
                        });
                    } else if(response.status && !response.data){
                        createElement(db, model, {id: id, value: article}).then((data) => {
                            if(data.status){
                                results[articleId].area[area].quantity = value;
                                document.getElementById('total'+articleId).value = calculateTotal(articleId);
                                results[articleId].total = calculateTotal(articleId);
                            }
                        });
                    }
                }
            )
            
        }
    }

    const updateElements = (connection, type) => {
        if(connection){
            allElements(connection, model).then(
                (response) => {
                    if(type === 1){
                        if(response.status && response.data.length > 0){
                            setLoading(true);
                            const data = response.data.map(item => item.value);
                            const keys = response.data.map(item => item.id);
                            updateAmountPhysicalTakeArray(data).then(
                                (result)=>{
                                    setLoading(false); 
                                    if(result.status){
                                        message(result.messages, result.status);
                                        deteletPhysicalTake(keys, connection);
                                        setViewAlert(true);
                                    } else if(result.offline){
                                        message(['No se pudo guardar la información, puede seguir funcionando sin conexión y, una vez que se restaure la conexión a internet, se llevará a cabo el almacenamiento automático de la misma.'], false);
                                    }
                                }
                            )
                        }
                    } else {
                        if(response.status && response.data.length > 0){
                            const data = response.data.map(item => item.value);
                            const keys = response.data.map(item => item.id);
                            updateAmountPhysicalTakeArray(data).then(
                                (result)=>{
                                    console.log(result);
                                    console.log(viewAlert);
                                    if(result.status){
                                        deteletPhysicalTake(keys, connection);
                                        setViewAlert(true);
                                    } else if (result.offline && viewAlert){
                                        setViewAlert(false);
                                        message(['No se pudo guardar la información, puede seguir funcionando sin conexión y, una vez que se restaure la conexión a internet, se llevará a cabo el almacenamiento automático de la misma.'], false);
                                    }
                                }
                            )
                        }
                    }
                }
            )
        }
    }

    const savePhysicalTake = () => {
        updateElements(db, 1);
    }

    function message(messages, type){
            let icon = (type) ? checkmarkCircleOutline : closeCircle;
            let color = (type) ? 'success' : 'secondary';
            messages.map((message) => (
                present({
                    message: message,
                    duration: 3000,
                    position: 'bottom',
                    color: color,
                    icon: icon
                })
            ));
        }

    const deteletPhysicalTake = (data, connection) => {
        data.forEach((id) => {
            deleteElement(connection, model, id).then((response) => {console.log(response)});
        })
    }

    function calculateTotal(article) {
        let total = 0;
        results[article].area.forEach(element => {
            total += parseFloat(element.quantity);
        });
        return total;
    }
    const onlyNumber = (e, item) => {
        document.getElementById(item).value = e.currentTarget.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0').replace(/(\.\d{3})\d+/g, '$1');
    }

    function searchOffline(){
        let isSearchAll = true;
        let resultOffline = structuredClone(dataFull);
        if (name !== "") {
            let orderResults = {};
            const newResults = Object.entries(resultOffline).filter(e => e[1].article_name.toLowerCase().includes(name.toLowerCase()));
            newResults.forEach(function (element) {
                orderResults[element[0]] = element[1];
            });
            isSearchAll = false;
            resultOffline = orderResults;
        } 

        if (code !== "") {
            let orderResults = {};
            const newResults = Object.entries(resultOffline).filter(e => e[1].article_code.toLowerCase().includes(code.toLowerCase()));
            newResults.forEach(function (element) {
                orderResults[element[0]] = element[1];
            })
            isSearchAll = false;
            resultOffline = orderResults;
        } 

        if(group !== ""){
            let searchGroup = group.split(',');
            searchGroup = searchGroup.map(elemento => elemento.trim());
            let orderResults = {};
            const newResults = Object.entries(resultOffline).filter(e => searchGroup.some(group => e[1].article_group.trim().includes(group)));
            newResults.forEach(function (element) {
                orderResults[element[0]] = element[1];
            })
            isSearchAll = false;
            resultOffline = orderResults;
        }

        if(area !== ""){
            let orderResults = {};
            let searchArea = area.split(',');
            searchArea = searchArea.map(elemento => elemento.trim());
            const newResults = Object.entries(resultOffline).map(item => { 
                item[1].area = item[1].area.filter(e => searchArea.some(area => e.area_name.trim().includes(area)));
                return item;
            });
            newResults.forEach(function (element) {
                if(element[1].area.length > 0){
                    orderResults[element[0]] = element[1];
                }
            })
            isSearchAll = false;
            resultOffline = orderResults;
        }

        if(movements !== 2){
            let orderResults = {};
            if(movements === 1){
                const newResults = Object.entries(resultOffline).map(item => {item[1].area = item[1].area.filter(e => e.system_quantity !== 0); return item; });
                newResults.forEach(function (element) {
                    if(element[1].area.length > 0){
                        orderResults[element[0]] = element[1];
                    }
                })
            } else if (movements === 0){
                const newResults = Object.entries(resultOffline).map(item => {item[1].area = item[1].area.filter(e => e.system_quantity === 0); return item; });
                newResults.forEach(function (element) {
                    if(element[1].area.length > 0){
                        orderResults[element[0]] = element[1];
                    }
                })
            }
            isSearchAll = false;
            resultOffline = orderResults;
        }

        if(isSearchAll){
            setResults(dataFull);
        } else {
            if(Object.keys(resultOffline).length === 0){
                present({
                    message: 'No existen artículos para los criterios de búsqueda seleccionados del inventario.',
                    duration: 6000,
                    position: 'bottom',
                    color: 'secondary',
                    icon: closeCircle
                })
            }
            setResults(resultOffline);
        }
    }

    const printBody = () => {
        const rowBody = Object.entries(results).map((item, key) => (
            <IonRow key={key} className={styles.itemArticle}>
                <IonCol size='12' align='center' className={styles.description}>
                    <b>Nombre</b> {item[1].name} <br></br> <b>Unidad</b> {item[1].unit}  - <b>Grupo</b> {item[1].group_name}
                </IonCol>
                {item[1].area.map((area, keyArea) => {
                    return (
                        <IonCol size='6' key={keyArea}>
                            <b className={styles.description} >{area.area_name}</b>
                            <IonInput
                                label="Outline input"
                                labelPlacement="floating"
                                fill="outline"
                                id={area.id_article + '-' + area.area_code}
                                placeholder={area.quantity}
                                onBlur={() => updateAmount(area, item[0], keyArea)}
                                onInput={(e) => onlyNumber(e, area.id_article + '-' + area.area_code)}
                                value={area.quantity !== 0? area.quantity : ''}
                            />
                        </IonCol>
                    );
                })
                }
                <IonCol size='6'>
                    <b className={styles.description}>Total</b>
                    <IonInput
                        label="Outline input"
                        labelPlacement="floating"
                        fill="outline"
                        value={item[1].total}
                        id={'total' + item[0]}
                        type="text"
                        readonly
                    />
                </IonCol>
            </IonRow>
        ));

        return rowBody;
    }

    return (
        <div className={styles.content}>
            <IonLoading isOpen={loading} message="Cargando..." />
            <IonList className={styles.listArticles}>
                {printBody()}
            </IonList>
            <IonFab slot="fixed" vertical="bottom" horizontal="end" className={styles.saveButton}>
                <IonFabButton onClick={()=>savePhysicalTake()}>
                    <IonIcon icon={save}></IonIcon>
                </IonFabButton>
            </IonFab>
        </div>
    );
};

export default List;
